import { cn } from "@/lib/utils";

type SkeletonProps = React.ComponentProps<"div"> & {
  variant?: "default" | "subtle";
};

function Skeleton({ className, variant = "default", ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "rounded-md",
        variant === "subtle"
          ? "bg-muted/30 animate-[pulse_3s_ease-in-out_infinite]"
          : "animate-pulse bg-primary/10",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
